import { useEffect } from "react";
import { useLenis } from "lenis/react";

// Locks background scrolling while an overlay/modal is open — WITHOUT losing the
// current scroll position. When Lenis is active we simply stop() it: Lenis adds the
// `lenis-stopped` class (see index.css → overflow:hidden) which blocks native scroll
// while preserving position. When there's no Lenis (rare), we fall back to a manual
// body scroll lock. Behaviour is identical on desktop & mobile.
export const useScrollLock = (active) => {
  const lenis = useLenis();
  useEffect(() => {
    if (!active) return;
    if (lenis) {
      lenis.stop();
      return () => lenis.start();
    }
    const body = document.body;
    const prevOverflow = body.style.overflow;
    const prevTouch = body.style.touchAction;
    body.style.overflow = "hidden";
    body.style.touchAction = "none";
    return () => { body.style.overflow = prevOverflow; body.style.touchAction = prevTouch; };
  }, [active, lenis]);
};
